<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2024-03-06 17:57:26
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2025-05-08 17:15:46
 * @FilePath: \front\src\views\Patient\components\special\components\eval-detail-4.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 入院评估 -->
<template>
  <div>
		<div style="font-size: 16px;">
			基础体征
			<el-tag v-if="!basicFinished" type="danger" size="mini" style="margin-left: 10px">未完成</el-tag>
			<el-tag v-else size="mini" style="margin-left: 10px">已完成</el-tag>
		</div>
		
		<el-form ref="form" label-width="60px" :inline="true" :rules="rules" :model="form">
			<div class="exam-item">
				<div>
					<el-form-item label="身高" prop="height">
						<el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form.height"></el-input> cm
					</el-form-item>
					<el-form-item label="体重" prop="weight">
						<el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form.weight"></el-input> kg
					</el-form-item>
				</div>
				<div>	
					<el-form-item label="收缩压" prop="sbp">
						<el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form.sbp"></el-input> mmHg
					</el-form-item>
					<el-form-item label="舒张压" prop="dbp">
						<el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form.dbp"></el-input> mmHg
					</el-form-item>
				</div>
			</div>		
		</el-form>

		<div style="text-align: center;">
			<el-button type="primary" :loading="isLoading" @click="onAssess">生成评估</el-button>
		</div>		
  </div>

</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import { EventBus } from '@/event-bus.js';
import dayjs from 'dayjs';

export default {  
	mixins: [mixin],
	props: {
		// 问卷是否已完成
		questSucc: Boolean,
		// 评估id
		id: Number,
		patientId: Number,
		// 其他参数
		otherData: Object
	},
	data(){
		return {
			noSidebar: true,   
			isLoading: false,
			form: {dataId:0,dataType:3,measuringTime:'',patientId: 0, height: '', weight: '', bmi:'',sportLevel: undefined,sbp: '', dbp: '',vitalSignsId: "人工录入" },
			rules: {
				height: {required: true, message: '请输入', trigger: 'blur'},
				weight: {required: true, message: '请输入', trigger: 'blur'},
				sbp: {required: true, message: '请输入', trigger: 'blur'},
				dbp: {required: true, message: '请输入', trigger: 'blur'},
			},
			filter:{
				patientId: 0,
				dataType: '',
				type:'',
				measuringTimeStart: '',
				measuringTimeEnd: '',
				date: [],
				pageNumber: 1,
				pageSize: 30
			},
			basic:{},
			basicFinished: false,
		}
	},
	watch: {
		form:{
			deep: true,
			handler(val, oldVal) {
				if(val.weight && val.height&& val.sbp&&val.dbp){
					this.basicFinished=true;
				}else{
					this.basicFinished=false;
				}
			}
		}
	},
	mounted() {
		this.filter.patientId = this.patientId;
		this.form.patientId = this.patientId;
		this.getBasicData()
	},  
	methods: {
		getBasicData(){
			// 获取身高体重
			api.getPatientLabBasic(this.filter).then(res => {
				if (res.code==1000) {
					if(res.data.length > 0){
						this.basic.weight = res.data[0].weight;
						this.basic.height = res.data[0].height;
						this.form.weight = this.basic.weight ? this.basic.weight : '';
						this.form.height = this.basic.height ? this.basic.height : '';
					}
				}else{
					this.$message.error(res.message);
				}
			});

			// 获取血压
			api.getPatientBloodPressure(this.filter).then(res => {
				if (res.code==1000) {
					if(res.data.length > 0){

						this.basic.sbp = res.data[0].sbp;
						this.basic.dbp = res.data[0].dbp;
			
						this.form.sbp = this.basic.sbp ? this.basic.sbp : '';
						this.form.dbp = this.basic.dbp ? this.basic.dbp : '';
					}
				}else{
					this.$message.error(res.message);
				}
			});
		},
		async init() {
			this.form.height = this.otherData.height;
			this.form.weight = this.otherData.weight;
		

		},	
		async onAssess() {
			if(this.form.weight !=this.basic.weight) {
				this.editBasic('weight', this.form.weight);
			}else if(this.form.height !=this.basic.height) {
				this.editBasic('height', this.form.height);
			}else if(this.form.sbp !=this.basic.sbp) {
				this.editBasic('sbp', this.form.sbp);
			}else if(this.form.dbp !=this.basic.dbp) {
				this.editBasic('dbp', this.form.dbp);
			}
			console.log(this.otherData,'=======dd')

			if (!this.questSucc) {
				return this.$message.warning('请先完成评估问卷');
			}
			this.assessForm();

			
		},		
		async assessForm() {
			if (this.isLoading) { return; }
			this.isLoading = true;
			this.form.SBP=this.form.sbp;
			this.form.DBP=this.form.dbp;
			const res = await api.assessCustomerEval({id: this.id, params: { examination: this.form }});
			this.isLoading = false;
			if (res.code != 1000) {return this.$message.error(res.message);}
			this.$emit('succ');
			EventBus.$emit('update-eval-data')
		},
		getBMI(){
			return (this.form.weight / Math.pow(this.form.height / 100, 2)).toFixed(1);
		},
		async editBasic(key, value) {
			const now=new Date().getTime();
			this.form.measuringTime=dayjs(now).format('YYYY-MM-DD HH:mm:ss');
			if(key=='weight'||key=='height') {
				this.form.bmi = this.getBMI();
				let res=await api.addPatientLabBasic(this.form)
			}else if(key=='sbp'||key=='dbp') {
				let res=await api.addPatientBloodPressure(this.form)
			}
			this.getBasicData()
		},	
	}
}
</script>
<style lang="less" scoped>
	/deep/.el-form-item__label{width: 80px!important;}
	
</style>
